export const multiTabsData = [
  {
    id: 5,
    nombre: "Buscador Turnos",
    params: { key: 5 },
    path: "/buscadorTurnos",
  },
  {
    id: 0,
    nombre: "Consultas médicas",
    carpeta: "ConsultaMedica",
    componente: "ConsultaMedica",
    params: { key: 0 },
    path: "/consultamedica",
  },
  {
    id: 1,
    nombre: "Estudios",
    carpeta: "Estudios",
    componente: "Estudios",
    params: { key: 1 },
    path: "/estudios",
  },
  {
    id: 2,
    nombre: "Laboratorio",
    carpeta: "Laboratorio",
    componente: "Laboratorio",
    params: { key: 2 },
    path: "/laboratorio",
  },
  {
    id: 3,
    nombre: "Recetas digitales",
    carpeta: "RecetasDigitales",
    componente: "RecetasDigitales",
    params: { key: 3 },
    path: "/recetasdigitales",
  },
];

// tipoTexto: valor que viene en item.tipoTexto del API /shared/centros para filtrar por categoría
export const multiTabsDataAtencionSinTurno = [
  {
    id: 0,
    nombreBase: "Clinica médica",
    tipoTexto: "Centros Clinica Med.",
    carpeta: "Clinicamedica",
    componente: "Clinicamedica",
    params: { key: 0 },
  },
  {
    id: 1,
    nombreBase: "Radiologia",
    tipoTexto: "Centros Radiologia",
    carpeta: "Radiologia",
    componente: "Radiologia",
    params: { key: 1 },
  },
  {
    id: 2,
    nombreBase: "Electrocardiograma",
    tipoTexto: "Centros Electrocardiograma",
    carpeta: "Electrocardiograma",
    componente: "Electrocardiograma",
    params: { key: 2 },
  },
  {
    id: 3,
    nombreBase: "Laboratorio",
    tipoTexto: "Centros Laboratorio",
    carpeta: "Laboratorio",
    componente: "Laboratorio",
    params: { key: 3 },
  },
];

export const multiTabDataMobilePaciente = [
  {
    id: 0,
    nombre: "Para mi",
  },
  {
    id: 1,
    nombre: "Para un familiar",
  },
];

export const multiTabDataMisLaboratorios = [
  {
    id: 0,
    nombre: "Ver mis estudios de laboratorios",
  },
];

export const multiTabDataMisInformes = [
  {
    id: 0,
    nombre: "Ver mis informes",
  },
];

export const multiTabDataMisMedicos = [
  {
    id: 0,
    nombre: "Ver todo",
  },
  {
    id: 1,
    nombre: "Especialistas",
  },
  {
    id: 2,
    nombre: "Laboratorios",
  },
  {
    id: 3,
    nombre: "Calificados",
  },
  {
    id: 4,
    nombre: "Sin calificar",
  },
];
